var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDam = function SvgDam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#46D581",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#dam_svg__a)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "M7.244 25.5h-4.3V13.864h4.295q1.778 0 3.062.698a4.78 4.78 0 0 1 1.989 2q.699 1.302.699 3.114 0 1.818-.7 3.125a4.78 4.78 0 0 1-1.982 2.006q-1.29.693-3.063.693m-1.488-2.398h1.38q.978 0 1.654-.33.681-.334 1.028-1.084.353-.756.353-2.012t-.353-2q-.352-.75-1.04-1.08-.682-.335-1.681-.335H5.756zm11.335 2.546q-.835 0-1.483-.279a2.3 2.3 0 0 1-1.017-.852q-.37-.574-.37-1.437 0-.727.256-1.228.256-.5.705-.812.45-.313 1.034-.472.585-.165 1.25-.221.744-.069 1.199-.143.455-.079.659-.221a.48.48 0 0 0 .21-.415v-.028q0-.438-.301-.676-.301-.24-.812-.239-.551 0-.887.239-.334.238-.426.659l-2.562-.091q.112-.796.585-1.42.477-.63 1.306-.99.836-.363 2.006-.363.835 0 1.54.199.705.193 1.227.568.523.37.807.91.29.54.29 1.232V25.5h-2.614v-1.216h-.068a2.5 2.5 0 0 1-.597.75q-.357.307-.846.46a3.6 3.6 0 0 1-1.091.154m.858-1.819q.45 0 .807-.181.363-.183.58-.5a1.3 1.3 0 0 0 .215-.75v-.83q-.12.063-.29.114-.164.051-.363.096-.2.045-.41.08-.21.034-.403.063a2.5 2.5 0 0 0-.67.193 1.06 1.06 0 0 0-.42.34.84.84 0 0 0-.143.49q0 .431.307.658.313.227.79.227m6.057 1.671v-8.727h2.642v1.602h.096q.273-.795.92-1.256.65-.46 1.546-.46.909 0 1.557.466.648.465.824 1.25h.09q.246-.779.955-1.244.711-.472 1.676-.472 1.24 0 2.012.796.773.79.773 2.17V25.5h-2.779v-5.239q0-.653-.335-.994-.334-.346-.87-.346-.573 0-.903.375-.324.369-.324.994v5.21h-2.67v-5.267q0-.608-.33-.96t-.869-.352a1.18 1.18 0 0 0-1.08.664 1.7 1.7 0 0 0-.153.75V25.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dam_svg__a",
    x1: 0,
    x2: 37.5,
    y1: 7.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6EE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1FF2C",
    stopOpacity: 0.22
  })))));
};
export default SvgDam;